import { createAction, props } from "@ngrx/store";
import { DateProvider } from "src/app/_models/DateProvider";
import { DateProviderActionTypes } from "src/app/constants/StoreConstants";

export const GetDateProvider = createAction(DateProviderActionTypes.GetDateProvider);

export const GetDateProviderSuccess = createAction(DateProviderActionTypes.GetDateProviderSuccess,
    props<{ dateProvider: DateProvider}>()
);

export const GetDateProviderError = createAction(DateProviderActionTypes.GetDateProviderError,
    props<{ error: any }>()
);